import { writable } from "svelte/store";
import { avatars } from "../environment";
export const avatar = writable(avatars[0]);
